"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mem2 = void 0;
const mem_1 = require("mem");
const mem = require("mem");
const mem2 = function (fn, options = {}) {
    const wrapped = mem((...args) => {
        const res = fn(...args);
        return !(res instanceof Promise) ? res
            : res.catch(err => {
                (0, mem_1.clear)(wrapped);
                throw err;
            });
    }, options);
    return wrapped;
};
exports.mem2 = mem2;
